import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./InquiryReplyInModel.css";
import FormFieldValidationError from '../../../Common/FormFieldValidationError/FormFieldValidationError';
// import FileAttachment from "./FileAttachment/FileAttachment";
import FileAttachment from "../FileAttachment/FileAttachment";
import InquiryReplyTitleBar from "../InquiryReplyTitleBar";
import axios from "axios";
import {RESOURCE_BASE_URL, WS_BASE_URL} from "../../../../configuration";
import Redirect from "react-router-dom/es/Redirect";
import Modal from "react-bootstrap/es/Modal";
import ShowMoreText from "react-show-more-text";

let stompClient = null;

class InquiryReplyInModel extends Component {

    constructor(props) {
        super(props);
        let today = new Date(),
            date = today.getFullYear() + ' -' + (today.getMonth() + 1) + ' -' + today.getDate();

        this.state = {
            email: "",
            subject: "",
            inquiry: "",
            reply: "",
            replyError: "",
            date: date,
            redirect: false,
            show: false,
            showError: false,

            isStompClientConnected : false,
            intervalId: -1,
            notificationToUser : null

        };

        this.onInputChange = this.onInputChange.bind(this);
        this.validateReply = this.validateReply.bind(this);
        this.saveReply = this.saveReply.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleShowError = this.handleShowError.bind(this);
        this.handleCloseError = this.handleCloseError.bind(this);

        //notification functions
        this.connectNotification = this.connectNotification.bind(this);
        this.onConnectedNotification = this.onConnectedNotification.bind(this);
        this.onErrorNotification = this.onErrorNotification.bind(this);

    }

    handleClose = () => {
        this.setState({
            show: false,
            redirect: true
        });
        this.props.handleCloseAll();
    };

    handleShow = () => {
        this.setState({
            show: true
        })
    };

    handleShowError = () => {
        this.setState({showError: true})
    };

    handleCloseError = () => {
        this.setState({
            showError: false,
        })
    };

    validateReply = () => {
        let reply = this.state.reply;
        return (reply !== "");
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            replyError: ""
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
        }
    }

    componentDidMount() {

        let inquiryId;

        if (inquiryId === undefined) {
            inquiryId = this.props.inquiryId;
        } else {
            inquiryId = this.props.match.params.id;
        }
        axios.get(RESOURCE_BASE_URL + 'api/users/inquiries/' + inquiryId)
            .then((res) => {
                this.setState({
                    email: res.data.email,
                    subject: res.data.subject,
                    inquiry: res.data.message,
                    notificationToUser : res.data.userId
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }


    saveReply = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };
        let resourceUrl = RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiryId + '/reply';
        // console.log("inside inquiry reply model");
        axios.post(resourceUrl
            , {
                reply: this.state.reply,
                repliedByAdminId: localStorage.getItem("userId"),
                isFromAdmin: 1
            }, axiosConfig)
            .then((res) => {
                // console.log("New reply saved", res);
                this.setState({show: true}, ()=>{
                    this.connectNotification();
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({showError: true});
            });

    };

    onSubmit = (event) => {
        event.preventDefault();
        let replyError = "";
        let validationPassed = true;

        if (!this.validateReply(event)) {
            validationPassed = false;
            replyError = "app.validation.inquiry-reply.invalid-reply";
        }

        if (validationPassed) {
            // console.log("Validation passed");
            this.saveReply();
        } else {

            this.setState({replyError});
        }
    };

    connectNotification = () => {
        if (!this.state.isStompClientConnected) {
            const Stomp = require('stompjs');
            var SockJS = require('sockjs-client');
            SockJS = new SockJS(WS_BASE_URL + "ws");
            stompClient = Stomp.over(SockJS);
            stompClient.connect({}, this.onConnectedNotification, this.onErrorNotification);
        }
    };

    onConnectedNotification = () => {

        this.setState({
            isStompClientConnected: true
        });
        clearInterval(this.state.intervalId);


        // Sending notification
        stompClient.send("/app/sendNotification",
            {},
            JSON.stringify({userId: this.state.notificationToUser, notificationMessage: 'NEW_INQUIRY_REPLY'})
        );

    };
    onErrorNotification = (error) => {
        //console.log("error occurred while connecting to ws" + error);

        if (this.state.intervalId !== -1) {
            clearInterval(this.state.intervalId);
        }
        let intervalId = setInterval(() => {
            this.connectNotification()
        }, 5000);
        this.setState({intervalId: intervalId});
    };

    render() {

        const {redirect} = this.state;

        if (redirect) {
            return <Redirect to='/admin/inquiries/viewAll'/>;
        }

        return (
            <div>
                {/*<div className="inquiry-reply-content">*/}
                {/*<div className="inquiry-reply-div">*/}
                <form onSubmit={this.onSubmit}>

                    {/*<InquiryReplyTitleBar email={this.state.email} date={this.state.date}/>*/}
                    {/**/}
                    {/*<hr/>*/}

                    {/*<div className="row">*/}
                    {/*<div className="inquiry-reply-row-margin">*/}
                    {/*<div className="col-md-2">*/}
                    {/*<div className="text-right">*/}
                    {/*<label>*/}
                    {/*<FormattedMessage id="app.inquiry-reply.subject"*/}
                    {/*defaultMessage="Subject"*/}
                    {/*description=""/>*/}
                    {/*</label>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="col-md-10 no-padding-left ">*/}
                    {/*<input type="text"*/}
                    {/*className="form-control input-sm"*/}
                    {/*name="subject"*/}
                    {/*disabled={true}*/}
                    {/*value={this.state.subject}*/}
                    {/*/>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="row">*/}
                    {/*<div className="inquiry-reply-row-margin">*/}
                    {/*<div className="col-md-2">*/}
                    {/*<div className="text-right">*/}
                    {/*<label>*/}
                    {/*<FormattedMessage id="app.inquiry-reply.inquiry"*/}
                    {/*defaultMessage="Inquiry"*/}
                    {/*description=""/>*/}
                    {/*</label>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="col-md-10 no-padding-left">*/}
                    {/*/!*<textarea type="text"*/}
                    {/*className="form-control"*/}
                    {/*name="inquiry"*/}
                    {/*disabled={true}*/}
                    {/*value={this.state.inquiry}*/}
                    {/*/>*!/*/}
                    {/*<ShowMoreText*/}
                    {/*lines={3}*/}
                    {/*more='詳細……'*/}
                    {/*less='閉じる……'*/}
                    {/*anchorClass=''*/}
                    {/*>*/}
                    {/*{this.state.inquiry}*/}
                    {/*</ShowMoreText>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    <div className="">
                        <div className="inquiry-reply-row-margin add-padding-left-inquiry resp-padding-modal">

                            <div className=" no-padding-left inquiry-reply-textarea-resp-admin">
                                <label>
                                    <FormattedMessage id="app.inquiry-reply.reply"
                                                      defaultMessage="Reply"
                                                      description=""/>
                                </label>
                                    <textarea type="text"
                                              className="form-control"
                                              name="reply"
                                              value={this.state.reply}
                                              onChange={this.onInputChange}
                                              rows={5}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="qc-reply-error-resp">
                            <FormFieldValidationError errors={this.state.replyError}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="inquiry-reply-row-margin">
                            <div className="col-md-8 custom-col-6"></div>

                            {/*<FileAttachment/>*/}
                            <div className="col-md-4 text-right custom-col-6">
                                <button className="btn btn-success set-width-btn-inquiry move-btn-inquiry-right-mobile" type="submit">
                                    <FormattedMessage id="app.inquiry-reply.button"
                                                      defaultMessage="Reply"
                                                      description=""/>
                                </button>


                                <button id="close-btn-reply-inq" className="btn btn-primary set-width-btn-inquiry  hide-in-web"
                                        onClick={this.props.handleCloseAll}>
                                    閉じる
                                </button>


                            </div>
                        </div>
                    </div>
                </form>
                {/*</div>*/}
                <Modal dialogClassName="message-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.inquiry-reply.inquiry-success"
                                              defaultMessage="Success"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-8 data-label">

                                    <FormattedMessage id="app.inquiry-reply.inquiry-sent"
                                                      defaultMessage="Reply sent successfully"
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleClose}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal dialogClassName="message-modal" show={this.state.showError} onHide={this.handleCloseError}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.inquiry-reply.inquiry-error"
                                              defaultMessage="Error"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-offset-1 data-label">

                                    <FormattedMessage id="app.inquiry-reply.inquiry-not-sent"
                                                      defaultMessage="Error occurred while sending the reply mail to user"
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleCloseError}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default InquiryReplyInModel;



// WEBPACK FOOTER //
// ./src/components/Admin/InquiryReply/InquiryReplyInModel/InquiryReplyInModel.js